import { render, staticRenderFns } from "./LandingBackgroundImage.vue?vue&type=template&id=0453e923&scoped=true"
import script from "./LandingBackgroundImage.vue?vue&type=script&lang=js"
export * from "./LandingBackgroundImage.vue?vue&type=script&lang=js"
import style0 from "./LandingBackgroundImage.vue?vue&type=style&index=0&id=0453e923&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453e923",
  null
  
)

export default component.exports